import type { TrackingData } from '@/types/common/tracking-data.type';

export interface ShiftResponse extends TrackingData {
    id: string;
    name: string;
    /** "HH:mm" format */
    startTime: string;
    /** "HH:mm" format */
    endTime: string;
    /** true when endTime <= startTime (crosses midnight) */
    isOvernight: boolean;
    isActive: boolean;
    sortOrder: number;
}

export interface ShiftPayload {
    name: string;
    startTime: string;
    endTime: string;
    isActive: boolean;
    sortOrder?: number;
}

export interface ShiftFormValues {
    name: string;
    startTime: string;
    endTime: string;
    isActive: boolean;
}

/** Compute isOvernight from raw time strings */
export function computeIsOvernight(startTime: string, endTime: string): boolean {
    if (!startTime || !endTime) return false;
    const [sh, sm] = startTime.split(':').map(Number);
    const [eh, em] = endTime.split(':').map(Number);
    const startMin = sh * 60 + sm;
    const endMin = eh * 60 + em;

    return endMin <= startMin;
}
